import React from 'react'
import ListPage from 'components/cases/listpage/ListPage'

export const categoryTitle = 'AI'
export const baseUrl = '/cases/ai/'

const AI: React.FC = () => {
  return <ListPage categoryTitle={categoryTitle} baseUrl={baseUrl} pageId={1} />
}

export default AI
